import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  Segment
} from "semantic-ui-react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { authSignup } from "../store/actions/auth";

const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password1: "",
    password2: ""
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error, token } = useSelector(state => state.auth);

  useEffect(() => {
    if (token) {
      navigate("/"); // redirect after signup
    }
  }, [token, navigate]);

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const { username, email, password1, password2 } = formData;
    dispatch(authSignup(username, email, password1, password2));
  };

  return (
    <Grid textAlign="center" style={{ height: "100vh" }} verticalAlign="middle">
      <Grid.Column style={{ maxWidth: 450 }}>
        <Header as="h2" color="teal" textAlign="center">
          Signup to your account
        </Header>
        {error && <p>{error.message}</p>}

        <Form size="large" onSubmit={handleSubmit}>
          <Segment stacked>
            <Form.Input
              onChange={handleChange}
              value={formData.username}
              name="username"
              fluid
              icon="user"
              iconPosition="left"
              placeholder="Username"
            />
            <Form.Input
              onChange={handleChange}
              value={formData.email}
              name="email"
              fluid
              icon="mail"
              iconPosition="left"
              placeholder="E-mail address"
            />
            <Form.Input
              onChange={handleChange}
              value={formData.password1}
              name="password1"
              fluid
              icon="lock"
              iconPosition="left"
              placeholder="Password"
              type="password"
            />
            <Form.Input
              onChange={handleChange}
              value={formData.password2}
              name="password2"
              fluid
              icon="lock"
              iconPosition="left"
              placeholder="Confirm password"
              type="password"
            />

            <Button
              color="teal"
              fluid
              size="large"
              loading={loading}
              disabled={loading}
            >
              Signup
            </Button>
          </Segment>
        </Form>

        <Message>
          Already have an account? <NavLink to="/login">Login</NavLink>
        </Message>
      </Grid.Column>
    </Grid>
  );
};

export default RegistrationForm;